export default __webpack_public_path__ + "static/media/facts.63edc68b.png";